import { Column } from 'angular-slickgrid';
import { BaseCrudComponent, FieldMapperHelper, ICrudService } from '@zendra/shared';
import { map, Observable, throwError } from 'rxjs';

type UnsupportedDto = Record<string, never>;

export abstract class OtherUseInconsistencyBase<TDto extends { id?: number }, TExcel> extends BaseCrudComponent<TDto & { id: number }, UnsupportedDto, UnsupportedDto, TExcel> {
  protected abstract readonly queryService: any;
  private cachedColumns: Column[] | null = null;

  get columns(): Column[] {
    this.cachedColumns ??= FieldMapperHelper.buildColumnsFromFields(this.fields, this.localizationService, this.injector);
    return this.cachedColumns;
  }

  service: ICrudService<TDto & { id: number }, UnsupportedDto, UnsupportedDto, TExcel> = {
    create: () => this.unsupported('create'), update: () => this.unsupported('update'), deleteByIds: () => this.unsupported('delete'),
    getList: query => this.queryService.getList(query).pipe(map((response: any) => ({ items: (response.items ?? []).map((item: TDto, index: number) => ({ ...item, id: item.id ?? (query?.skipCount ?? 0) + index + 1 })), totalCount: response.totalCount ?? 0 }))),
    getDownloadToken: () => this.queryService.getDownloadToken(), getListAsExcelFile: input => this.queryService.getListAsExcelFile(input),
  };

  protected prepareUpdateDto(): UnsupportedDto { return {}; }
  private unsupported<T>(operation: string): Observable<T> { return throwError(() => new Error(`Other Use inconsistencies are read-only; ${operation} is not supported.`)); }
}
